import { React, useEffect } from "react";
import { FormControl, InputLabel, MenuItem, Select, Box } from "@mui/material";
import { useSelector } from "react-redux";

export const FiltroTiempoRealSection = ({
    visualizacion,
    onVisualizacionChange,
    region,
    onRegionChange,
    sucursal,
    onSucursalChange,
    verpor,
    onverporchange,
    dataRegiones = [],
    dataSucursales = [],
    rol
}) => {
    const { idempleado } = useSelector((state) => state.usuario);

    useEffect(() => {
        if (
            (rol === "UREG" || rol === "GESU" || rol === "EVUS") &&
            dataRegiones.length === 1 &&
            region !== dataRegiones[0].idestado
        ) {
            onRegionChange(dataRegiones[0].idestado);
        }
    }, [rol, dataRegiones, region, onRegionChange]);

    useEffect(() => {
        if ((rol === "GESU" || rol === "EVUS") && dataSucursales.length === 1 && sucursal !== dataSucursales[0].idsucursal) {
            onSucursalChange(dataSucursales[0].idsucursal);
        }
    }, [rol, dataSucursales, sucursal, onSucursalChange]);

    useEffect(() => {
        if (sucursal !== 0) {
            onSucursalChange(0);
        }
    }, [region]);

    const sucursalesFiltradas =
        region === "0" || region === 0
            ? dataSucursales
            : dataSucursales.filter((s) => s.idestado === region);

    const regionUnica =
        (rol === "UREG" || rol === "GESU" || rol === "EVUS") && dataRegiones.length === 1
            ? dataRegiones[0]
            : null;

    const sucursalUnica =
        (rol === "GESU" || rol === "EVUS") && dataSucursales.length === 1 ? dataSucursales[0] : null;
    return (
        <Box
            className="filtro-tiempo-real"
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginBottom: 2,
                mt: 3,
                width: "calc(100% - 40px)",
            }}
        >
            {/* Select: Forma de visualización */}
            <FormControl size="small" sx={{ flex: 1 }}>
                <InputLabel id="select-visualizacion-label">
                    Forma de visualización
                </InputLabel>
                <Select
                    labelId="select-visualizacion-label"
                    value={visualizacion}
                    label="Forma de visualización"
                    onChange={(e) => onVisualizacionChange(e.target.value)}
                >
                    <MenuItem value="sucursal">Por sucursal</MenuItem>
                    <MenuItem value="asesor">Por asesor</MenuItem>
                </Select>
            </FormControl>

            {/* Select: Región */}
            <FormControl size="small" sx={{ flex: 1 }}>
                <InputLabel id="select-region-label">Región</InputLabel>
                <Select
                    labelId="select-region-label"
                    value={region}
                    label="Región"
                    onChange={(e) => onRegionChange(e.target.value)}
                    // Solo deshabilitar si tiene una sola región disponible
                    disabled={
                        (rol === "UREG" || rol === "GESU" || rol === "EVUS") &&
                        dataRegiones.length === 1
                    }
                >
                    {regionUnica ? (
                        <MenuItem key={regionUnica.idestado} value={regionUnica.idestado}>
                            {regionUnica.region}
                        </MenuItem>
                    ) : (
                        [
                            <MenuItem key="0" value="0">
                                Consolidado
                            </MenuItem>,
                            ...dataRegiones.map((r) => (
                                <MenuItem key={r.idestado} value={r.idestado}>
                                    {r.region}
                                </MenuItem>
                            )),
                        ]
                    )}
                </Select>
            </FormControl>
            {/* Select: Sucursal */}
            {visualizacion === "asesor" && (
                <FormControl size="small" sx={{ flex: 1 }}>
                    <InputLabel id="select-sucursal-label">Sucursal</InputLabel>
                    <Select
                        labelId="select-sucursal-label"
                        value={sucursal}
                        label="Sucursal"
                        onChange={(e) => onSucursalChange(e.target.value)}
                        disabled={(rol === "GESU" || rol === "EVUS") && idempleado != 5886} // Bloquea sucursal solo para GESU
                    >
                        {(rol === "GESU" || rol === "EVUS") && sucursalUnica ? (
                            <MenuItem key={sucursalUnica.idsucursal} value={sucursalUnica.idsucursal}>
                                {sucursalUnica.sucursal}
                            </MenuItem>
                        ) : (
                            [
                                <MenuItem key="0" value="0">
                                    Consolidado
                                </MenuItem>,
                                ...sucursalesFiltradas.map((s) => (
                                    <MenuItem key={s.idsucursal} value={s.idsucursal}>
                                        {s.sucursal}
                                    </MenuItem>
                                )),
                            ]
                        )}
                    </Select>
                </FormControl>
            )}

            <FormControl size="small" sx={{ flex: 1 }}>
                <InputLabel id="select-verpor-label">
                    Ver por
                </InputLabel>
                <Select
                    labelId="select-verpor-label"
                    value={verpor}
                    label="Ver por"
                    onChange={(e) => onverporchange(e.target.value)}
                >
                    {/* <MenuItem value="unidadesmonto">Unidades e importes</MenuItem> */}
                    <MenuItem value="unidades">Unidades</MenuItem>
                    <MenuItem value="montos">Importes</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};
